import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="bg-muted rounded-full p-6 md:p-8 mb-6">
        <Icon name="Images" size={48} color="var(--color-muted-foreground)" />
      </div>
      <h3 className="text-xl md:text-2xl font-semibold mb-2">No Galleries Yet</h3>
      <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
        Start showcasing your work by creating your first gallery. Connect with Google Drive and share your media with clients.
      </p>
      <Button
        variant="default"
        size="lg"
        iconName="Plus"
        iconPosition="left"
        onClick={() => navigate('/gallery-creation')}
      >
        Create Your First Gallery
      </Button>
    </div>
  );
};

export default EmptyState;